import { default as ByteChunksView, ReadonlyByteChunksView } from '../byteChunksView';
import { chunkSizes } from '../chunk';
import { calculateCrcFromChunks } from '../crc';
import { byteChunksToInt, numberToBytes } from '../utils';

export default class PngChunkView
{
    public readonly length: number;
    protected readonly rawType: ByteChunksView;
    protected readonly rawContent: ByteChunksView;
    protected readonly rawCrc: ByteChunksView;

    constructor(private readonly rawData: Uint8Array[], fixedLength?: number)
    {
        const lengthAndTail = new ByteChunksView(rawData).split(chunkSizes.LENGTH);

        const lengthChunks: ByteChunksView = lengthAndTail[0];

        this.length = byteChunksToInt(lengthChunks.getRawChunks());
        if (fixedLength !== undefined && this.length !== fixedLength)
        {
            throw new Error(
                `Invalid chunk length (actual: ${this.length}, expected: ${fixedLength})`,
            );
        }

        let tail = lengthAndTail[1];

        [this.rawType, tail] = tail.split(chunkSizes.TYPE);
        [this.rawContent, this.rawCrc] = tail.split(this.length);

        if (this.rawCrc.size !== chunkSizes.CRC)
        {
            throw new Error('Invalid chunk length');
        }
    }

    get type(): string
    {
        let type = '';

        for (const charCode of this.rawType.getBytes())
        {
            type += String.fromCharCode(charCode);
        }

        return type;
    }

    set type(value)
    {
        const typeBytes = new Uint8Array(chunkSizes.TYPE);

        for (let i = 0; i < value.length; i++)
        {
            typeBytes[i] = value.charCodeAt(i);
        }
        this.rawType.setBytes(typeBytes);
    }

    get content(): ReadonlyByteChunksView
    {
        return this.rawContent;
    }

    get crc(): number
    {
        return byteChunksToInt(this.rawCrc.getRawChunks());
    }

    getRawData(): Uint8Array[]
    {
        return this.rawData;
    }

    recalculateCrc(): void
    {
        const crc = calculateCrcFromChunks(
            [
                ...this.rawType.getRawChunks(),
                ...this.rawContent.getRawChunks(),
            ],
        );

        this.setCrc(crc);
    }

    private setCrc(value: number)
    {
        const bytes = numberToBytes(value, 4);

        this.rawCrc.setBytes(bytes);
    }
}
